import React, { useState, useEffect } from 'react';
import StudentHeader from '../../Components/StudentHeader';
import Footer from '../../Components/Footer';
import HttpInterceptor from '../../lib/HttpInterceptor';
import { toast } from 'react-toastify';
import ConfirmDialog from '../../Components/ConfirmDialog';

const ResellerEarnings = () => {
  const [pendingPayouts, setPendingPayouts] = useState(null);
  const [payoutHistory, setPayoutHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [confirmConfig, setConfirmConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    onConfirm: () => { },
    variant: 'default'
  });

  useEffect(() => {
    fetchPendingPayouts();
    fetchPayoutHistory();
  }, []);

  const fetchPendingPayouts = async () => {
    try {
      const response = await HttpInterceptor.get('/api/payouts/pending');
      setPendingPayouts(response.data.data);
    } catch (error) {
      console.error('Error fetching pending payouts:', error);
    }
  };

  const fetchPayoutHistory = async () => {
    try {
      const response = await HttpInterceptor.get('/api/payouts/history');
      setPayoutHistory(response.data.data || []);
    } catch (error) {
      console.error('Error fetching payout history:', error);
    } finally {
      setLoading(false);
    }
  };

  const executePayoutRequest = async () => {
    try {
      await HttpInterceptor.post('/api/payouts/request');
      toast.success('Payout request submitted successfully');
      fetchPendingPayouts();
      fetchPayoutHistory();
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to request payout');
    }
  };

  const handleRequestPayout = () => {
    setConfirmConfig({
      isOpen: true,
      title: 'Request Payout',
      message: 'Are you sure you want to request a payout for all pending earnings?',
      onConfirm: executePayoutRequest,
      variant: 'default'
    });
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-white to-gray-100">
      <StudentHeader />
      
      <main className="flex-1 container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Earnings & Payouts</h1>

        {/* Pending Payouts */}
        {pendingPayouts && (
          <div className="bg-white rounded-xl shadow-md p-6 mb-6">
            <h2 className="text-xl font-bold mb-4">Pending Payouts</h2>
            <div className="flex justify-between items-center mb-4">
              <div>
                <p className="text-gray-600">Total Pending</p>
                <p className="text-3xl font-bold text-purple-600">
                  ₹{pendingPayouts.totalPending?.toFixed(2) || '0.00'}
                </p>
                <p className="text-sm text-gray-500 mt-2">
                  {pendingPayouts.orderCount || 0} orders pending payout
                </p>
              </div>
              <button
                onClick={handleRequestPayout}
                disabled={!pendingPayouts.totalPending || pendingPayouts.totalPending === 0}
                className="px-6 py-3 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50"
              >
                Request Payout
              </button>
            </div>
          </div>
        )}

        {/* Payout History */}
        <div className="bg-white rounded-xl shadow-md p-6">
          <h2 className="text-xl font-bold mb-4">Payout History</h2>
          {loading ? (
            <div className="flex justify-center py-10">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
            </div>
          ) : payoutHistory.length === 0 ? (
            <p className="text-gray-500 text-center py-10">No payout history</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b">
                    <th className="text-left p-4">Date</th>
                    <th className="text-left p-4">Amount</th>
                    <th className="text-left p-4">Commission</th>
                    <th className="text-left p-4">Status</th>
                    <th className="text-left p-4">Transaction ID</th>
                  </tr>
                </thead>
                <tbody>
                  {payoutHistory.map(payout => (
                    <tr key={payout._id} className="border-b">
                      <td className="p-4">{new Date(payout.createdAt).toLocaleDateString()}</td>
                      <td className="p-4">₹{payout.netAmount?.toFixed(2)}</td>
                      <td className="p-4">₹{payout.commissionDeducted?.toFixed(2)}</td>
                      <td className="p-4">
                        <span className={`px-2 py-1 rounded text-sm ${
                          payout.status === 'completed' ? 'bg-green-100 text-green-700' :
                          payout.status === 'processing' ? 'bg-yellow-100 text-yellow-700' :
                          payout.status === 'failed' ? 'bg-red-100 text-red-700' :
                          'bg-gray-100 text-gray-700'
                        }`}>
                          {payout.status}
                        </span>
                      </td>
                      <td className="p-4">{payout.transactionId || 'N/A'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </main>

      <Footer />

      <ConfirmDialog
        isOpen={confirmConfig.isOpen}
        onClose={() => setConfirmConfig({ ...confirmConfig, isOpen: false })}
        onConfirm={confirmConfig.onConfirm}
        title={confirmConfig.title}
        message={confirmConfig.message}
        variant={confirmConfig.variant}
      />
    </div>
  );
};

export default ResellerEarnings;



